import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { Button, FlexboxGrid } from 'rsuite'
import { useSearchBox } from 'react-instantsearch'

import useUrls from '../../../services/useUrls'
import { QueryParam } from '../../../utils/constants'
import { clearSearch } from '../../../utils/util'
import ClearFilterIcon from '../../Icons/ClearFilterIcon'

import styles from '../../../styles/ProductCatalog.module.less'

const EmptySearchButton: FC = () => {
  const { t } = useTranslation('products')
  const { pushT } = useUrls()
  const { asPath, query } = useRouter()
  const { clear } = useSearchBox()

  const searchQuery = query[QueryParam.search]

  const onClearSearch = () => {
    const url = clearSearch(asPath)
    if (url) {
      clear()
      pushT(url, undefined, { shallow: true })
    }
  }

  if (!searchQuery) return null
  return (
    <Button
      appearance="subtle"
      className={`padding-zero padding-right-spacer-half ${styles['clear-search']}`}
      onClick={onClearSearch}
    >
      <FlexboxGrid align="middle">
        <ClearFilterIcon />
        <div className="margin-left-spacer">{t('Empty search')}</div>
      </FlexboxGrid>
    </Button>
  )
}

export default EmptySearchButton
